<template>
  <b-row>
    <b-col cols="12">
      <router-link :to="{ name: 'EXABAgreementsList' }" class="mb-1 btn btn-sm btn-default float-right">
        <span>{{$t('buttons.backToList')}}</span>
      </router-link>
    </b-col>
    <b-col cols="12" class="mt-2">
      <b-card>
        <div class="card-body">
          <Form
              :key="$route.name"
              :handle-submit="handleSubmit"
              :values="item"
              :violations="violations">
          </Form>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import Form from './Form'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Create',
  components: {
    Form
  },

  watch: {
    'created' (val) {
      if (val) {
        this.reset()
        this.$router.push({ name: 'EXABAgreementsList' })
      }
    },
    '$route.name' () { // Do zmiany stanu pomiędzy tworzeniem oferty a tworzeniem umowy
      this.reset()
    }
  },

  computed: {
    item () {
      let initialItem = this.initialItem
      if (this.$route.name === 'EXABAgreementsCreateOffers') {
        initialItem.type = 1
      } else {
        initialItem.type = 0
      }
      return initialItem
    },
    ...mapGetters({
      created: 'agreements/create/getCreated',
      initialItem: 'agreements/create/getItem',
      violations: 'agreements/create/violations'
    })
  },
  beforeDestroy () {
    this.reset()
  },

  methods: {
    handleSubmit () {
      this.create(this.item)
    },
    ...mapActions({
      create: 'agreements/create/create'
    }),
    ...mapMutations({
      reset: 'agreements/create/reset'
    })
  }
}
</script>
